import React, { useEffect, useState, Fragment } from "react";
import { Helmet } from 'react-helmet';
import CBAHeader from "../../components/Header/CBAHeader";
import CBAFooter from "../../components/Footer/CBAFooter";
import Section1AR from "../../components/LandingPage/Section1AR/Section1AR";
import Section3 from "../../components/LandingPage/Section3/Section3";
import CBAEmployerForm from "./CBAEmployerForm";
import { userService } from "../../_services";
import "./CBA.css";

const defaultContent = {
  hero: {
    heading: "Boost Your Cash Flow with",
    highlight: "AI-Powered",
    headingEnd: "Invoice Collection",
    subheading: "Our advanced AI takes the hassle out of chasing unpaid invoices...",
    button1: "Signup Now For Free",
    button2: "Explore Features",
    demoHowItWorks: {
        title: 'How the Demo works...',
        line1: "Just fill out the fields below, press 'Submit'...",
        line2: 'Our simulator will call you...',
        line3: 'Answer and interact with our simulator',
        line4: 'Experience our AI driven accounts first hand',
        line5: 'Start your demo now...'
    }
  },
  banner: {
    heading: "AI-powered invoice chaser...",
    button: "Get Started Today!",
  },
  features: {
    tag: "FEATURES",
    description: "Explore our Invoice Chaser Tool",
    accordionItems: [
      { heading: 'Your AI-Powered Invoice Follow-ups', description: 'Default description...' },
    ]
  }
};
export default function AccountsReceivable() {
  const [loading, setLoading] = useState(true);
  const [pageContent, setPageContent] = useState(null);
  const [demoFormSettings, setDemoFormSettings] = useState(null);
  const [expanded, setExpanded] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const whitelabelDomain = window.location.hostname;
    const fetchHomepageContent = async () => {
      try {
        const response = await userService.aiRequest({
          method: 'get-page-content',
          data: { whitelabel_domain: whitelabelDomain, page_name: 'homepage' }
        }, false);

        if (response.data?.content && Object.keys(response.data.content).length > 0) {
          setPageContent(response.data.content);
          if (response.data.customJs) {
            const script = document.createElement('script');
            script.innerHTML = response.data.customJs;
            document.body.appendChild(script);
          }
        } else {
          setPageContent(defaultContent);
        }
      } catch (error) {
        console.error("Failed to fetch homepage settings:", error);
        setPageContent(defaultContent);
      }

      try {
        const demoSettingsResponse = await userService.aiRequest({
          method: 'get-demo-form-settings',
          data: { whitelabel_domain: whitelabelDomain }
        }, false);

        if (demoSettingsResponse.data?.settings) {
          setDemoFormSettings(demoSettingsResponse.data.settings);
        }
      } catch (error) {
        console.error("Failed to fetch demo form settings:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchHomepageContent();

    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const displayAccordionData = React.useMemo(() => {
    if (!pageContent?.features?.accordionItems) return [];
    const sourceData = pageContent.features.accordionItems.map(item => ({
        heading: <div className="mr-2">{item.heading}</div>,
        description: <div dangerouslySetInnerHTML={{ __html: item.description.replace(/\n/g, '<br />') }} />
    }));
    if (isMobile && !expanded) return sourceData.slice(0, 3);
    return sourceData;
  }, [pageContent, isMobile, expanded]);

  const handleToggleExpand = () => setExpanded(prev => !prev);

  if (loading || !pageContent) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <div className="spinner-border text-primary" role="status">
          <span className="sr-only">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <div className="cbaPageWrap">
      <Helmet>
        <title>Boost Your Cash Flow with AI-Powered Invoice Collection</title>
      </Helmet>
      <CBAHeader />
      <Section1AR
        heading={
          <div className="fw-bold heading">
            {pageContent.hero.heading}<br />
            <span className="px-2" style={{ backgroundColor: 'rgba(0, 101, 255, 0.1)', color: '#0065FF', borderRadius: '8px', padding: '2px 12px' }}>
              {pageContent.hero.highlight}
            </span>{" "}
            {pageContent.hero.headingEnd}
          </div>
        }
        subHeading={pageContent.hero.subheading}
        buttons={
          <>
            <a href="/accounts/signup" className="text-decoration-none">
              <button className="border-0 px-4 py-2 primaryButton">{pageContent.hero.button1}</button>
            </a>
            <a href="#employers-feature" className="text-decoration-none">
              <button className="border-0 px-4 py-2 secondaryButton">{pageContent.hero.button2}</button>
            </a>
          </>
        }
        image={<CBAEmployerForm howItWorksContent={pageContent.hero.demoHowItWorks} demoFormSettings={demoFormSettings} />}
        mobileImage={<CBAEmployerForm howItWorksContent={pageContent.hero.demoHowItWorks} demoFormSettings={demoFormSettings} />}
      />
      
      <div className="section2">
        <div className="heading" style={{ color: '#fff' }}>
          {pageContent.banner?.heading.split(',').map((line, index) => (
            <Fragment key={index}>{line}{index < pageContent.banner.heading.split(',').length - 1 && <br />}</Fragment>
          ))}
        </div>
        <div className="sec-2-btn">
          <a href="/accounts/signup" className="text-decoration-none">
            <button className="border-0 px-5 py-2 primaryButton">{pageContent.banner?.button}</button>
          </a>
        </div>
      </div>
      
      <div id="employers-feature">
        <Section3
          accrodianData={displayAccordionData}
          tagName={pageContent.features.tag}
          description={pageContent.features.description}
          image={null}
          mobilebutton={
            isMobile && pageContent.features.accordionItems.length > 3 ? (
              <button className={`border-0 px-5 py-2 ${expanded ? 'secondaryButton' : 'primaryButton'}`} onClick={handleToggleExpand}>
                {expanded ? "Show Less" : "Show All Features"}
              </button>
            ) : null
          }
        />
      </div>
      
      <CBAFooter />
    </div>
  );
}